import { useCallback, useEffect, useRef, useState } from 'react'

import { axiosInstance } from '../../../../../hooks/useAxios'
import { IStockBackfillStatus } from '../types'

const POLL_MS = 5000

// สถานะตัดสต๊อกย้อนหลังของร้าน — โหลดตอน mount / เปลี่ยนร้าน แล้ว poll ต่อเฉพาะตอนที่ยังรันอยู่
// onFinished ยิงตอนสถานะเปลี่ยนจาก IN_PROGRESS → จบ เพื่อให้ผู้เรียกโหลดรายงานใหม่
export const useStockBackfillStatus = (
  shopId?: string,
  onFinished?: () => void,
) => {
  const [status, setStatus] = useState<IStockBackfillStatus | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const wasRunning = useRef<boolean>(false)
  const finishedRef = useRef(onFinished)
  finishedRef.current = onFinished
  // สลับร้านเร็ว ๆ แล้วคำตอบของร้านเก่ามาทีหลัง → ทิ้ง ไม่งั้นจำนวนค้างเป็นของอีกร้าน
  const shopIdRef = useRef(shopId)
  shopIdRef.current = shopId

  const fetchStatus = useCallback(async () => {
    try {
      const res = await axiosInstance.get<IStockBackfillStatus>(
        '/tiktok/backfill-stock/status',
        { params: shopId ? { shopId } : {} },
      )
      if (shopIdRef.current !== shopId) {
        return
      }
      setStatus(res.data)
      if (wasRunning.current && res.data?.status !== 'IN_PROGRESS') {
        finishedRef.current?.()
      }
      wasRunning.current = res.data?.status === 'IN_PROGRESS'
    } catch {
      // สถานะเป็นข้อมูลเสริม — ล้มก็ไม่ต้องขึ้น error ทับหน้าจอ
    } finally {
      setIsLoading(false)
    }
  }, [shopId])

  useEffect(() => {
    fetchStatus()
  }, [fetchStatus])

  useEffect(() => {
    if (status?.status !== 'IN_PROGRESS') {
      return
    }
    const timer = setInterval(fetchStatus, POLL_MS)
    return () => clearInterval(timer)
  }, [status?.status, fetchStatus])

  return {
    status,
    isLoading,
    isRunning: status?.status === 'IN_PROGRESS',
    pendingOrders: status?.pendingOrders ?? 0,
    refetch: fetchStatus,
  }
}
